module.exports = (__webpack_require__("vB+P"))(93);


//////////////////
// WEBPACK FOOTER
// delegated ../src/store/index.js from dll-reference main
// module id = IcnI
// module chunks = 73